export default __webpack_public_path__ + "static/media/thirdsteplg.c0502bd9.png";